import { Component, EventEmitter, HostListener, inject, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { DrawerService } from './drawer.service';
import { Subscription } from 'rxjs';
import { DEFAULT_DRAWER_CONFIG, DEFAULT_DRAWER_POSITION, DEFAULT_DRAWER_STATE, DISPLAY_IN_OUT_DRAWER_TRIGGER, DrawerConfig, DrawerPosition, DrawerState, MOBILE_DRAWER_CONFIG, DEFAULT_DRAWER_WIDTH, SLIDE_IN_OUT_TRIGGER } from './drawer';
import { CloseIconComponent } from '../icon/close-icon/close-icon.component';
import { CommonModule } from '@angular/common';
import { WindowRef } from "@gene-ai/ui/services/window/window-ref.service";

@Component({
    selector: 'gene-drawer',
    templateUrl: './drawer.component.html',
    styleUrls: ['./drawer.component.css'],
    imports: [CommonModule, CloseIconComponent],
    animations: [DISPLAY_IN_OUT_DRAWER_TRIGGER, SLIDE_IN_OUT_TRIGGER]
})
export class DrawerComponent implements OnInit, OnDestroy {
    @Input() id!: string;
    @Input() position: DrawerPosition = DEFAULT_DRAWER_POSITION;
    @Input() config: DrawerConfig = DEFAULT_DRAWER_CONFIG;

    @Input() header?: string;
    @Input() subheader?: string;

    @Output() close = new EventEmitter<void>();

    protected drawerService = inject(DrawerService);

    private drawerSubscription!: Subscription;
    private isMobile: boolean = WindowRef.innerWidth <= DEFAULT_DRAWER_WIDTH;

    drawerState: DrawerState = DEFAULT_DRAWER_STATE;
    contentState: DrawerState = DEFAULT_DRAWER_STATE;

    ngOnInit(): void {
        this.drawerService.register(this.id);
        this.drawerSubscription = this.drawerService.getDrawerState(this.id)
            .subscribe({
                next: (state: DrawerState) => {
                    if (state === 'in') {
                        this.openDrawer();
                    } else {
                        this.dismissDrawer();
                    }
                }
            });
    }

    ngOnDestroy(): void {
        if (this.drawerSubscription) {
            this.drawerSubscription.unsubscribe();
            this.drawerService.unregister(this.id);
        }
    }

    @HostListener('window:resize')
    onResize() {
        const currentlyMobile = WindowRef.innerWidth <= DEFAULT_DRAWER_WIDTH;

        if (this.isMobile === currentlyMobile) {
            return;
        }

        this.isMobile = currentlyMobile;
        this.config = !this.isMobile ? DEFAULT_DRAWER_CONFIG : MOBILE_DRAWER_CONFIG;
    }

    private openDrawer(): void {
        this.drawerState = 'in';
        this.contentState = 'in';
    }

    private dismissDrawer(): void {
        this.contentState = 'out';
        setTimeout(() => {
            this.drawerState = 'out';
            this.close.emit();
        }, this.config.animationTimeout);
    }
}
